import { render, staticRenderFns } from "./ReportCustomLegend.vue?vue&type=template&id=28080432&scoped=true"
import script from "./ReportCustomLegend.vue?vue&type=script&lang=js"
export * from "./ReportCustomLegend.vue?vue&type=script&lang=js"
import style0 from "./ReportCustomLegend.vue?vue&type=style&index=0&id=28080432&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28080432",
  null
  
)

export default component.exports